import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import {
    deliveryStatusDisplayNames,
    convertDeliveryStatusToInternalName,
} from 'lib/constants';
import React, { FC, ReactNode, useEffect, useState } from 'react';

export const StatusSelector: FC<{
    value: string;
    onChange: (s: string) => void;
    disabled?: boolean;
}> = ({ value, onChange, disabled }) => {
    const [status, setStatus] = useState<string>(
        value ? convertDeliveryStatusToInternalName[value] : ''
    );

    const selectedNewStatus = (
        event: SelectChangeEvent<string>,
        _child: ReactNode
    ) => {
        setStatus(convertDeliveryStatusToInternalName[event.target.value]);
        onChange(convertDeliveryStatusToInternalName[event.target.value]);
    };

    useEffect(() => {
        if (value) {
            setStatus(convertDeliveryStatusToInternalName[value.toLowerCase()]);
        }
    }, [value]);

    return (
        <Select
            data-testid="StatusSelector"
            disabled={disabled}
            value={status}
            onChange={selectedNewStatus}
            variant="standard"
            label="Status"
            displayEmpty
            sx={{ minWidth: '100%' }}
            renderValue={
                status ? undefined : () => <span>Please select a status</span>
            }
        >
            {deliveryStatusDisplayNames.map((stat) => (
                <MenuItem
                    key={convertDeliveryStatusToInternalName[stat]}
                    value={convertDeliveryStatusToInternalName[stat]}
                >
                    {stat}
                </MenuItem>
            ))}
        </Select>
    );
};
